import React from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet-async';

const PageWrapper = styled.div`
  min-height: 100vh;
  padding: var(--spacing-4xl) 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Content = styled.div`
  text-align: center;
  max-width: 600px;
  padding: 0 var(--spacing-lg);
`;

const NotFoundPage = () => {
    return (
        <PageWrapper>
            <Helmet>
                <title>Page Not Found - TikPlat</title>
            </Helmet>
            <Content>
                <h1>404 - Page Not Found</h1>
                <p>The page you're looking for doesn't exist.</p>
            </Content>
        </PageWrapper>
    );
};

export default NotFoundPage; 